import type { HTMLAttributes, ReactNode } from "react";
import { classNames } from "../utils/classNames";

export type StatusBadgeTone = "neutral" | "info" | "success" | "warning" | "danger";

export type StatusBadgeProps = HTMLAttributes<HTMLSpanElement> & {
  children: ReactNode;
  tone?: StatusBadgeTone;
  icon?: ReactNode;
  showDot?: boolean;
  /** 只用于真实的持续运行状态；警告和错误状态不得连续闪烁。 */
  isAnimated?: boolean;
};

export function StatusBadge({
  children,
  className,
  icon,
  isAnimated = false,
  showDot = false,
  tone = "neutral",
  ...props
}: StatusBadgeProps) {
  const canAnimate = isAnimated && tone === "info";

  return (
    <span
      {...props}
      className={classNames(
        "herskin-status-badge",
        `herskin-status-badge--${tone}`,
        canAnimate && "herskin-status-badge--animated",
        className,
      )}
    >
      {showDot ? <span className="herskin-status-badge__dot" aria-hidden="true" /> : null}
      {icon ? (
        <span className="herskin-status-badge__icon" aria-hidden="true">
          {icon}
        </span>
      ) : null}
      <span>{children}</span>
    </span>
  );
}
